import { render, staticRenderFns } from "./VGMEdit.vue?vue&type=template&id=6d458f06&scoped=true&"
import script from "./VGMEdit.vue?vue&type=script&lang=js&"
export * from "./VGMEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d458f06",
  null
  
)

export default component.exports